import vue       from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';
import Auth from '../../../interfaces/Auth';

@Component({
  template: require('./app-header.html'),
  
  props: {
    authorized: Boolean
  }
})
export class AppHeader extends vue {

  auth = IocContainer.get < Auth > (SERVICES.AUTH);

  header = true;

  logout() {
    this.auth.logout()
    }

    get headerClass() {
      return (this.header) ? 'collapse navbar-collapse' : 'navbar-collapse navbar-mobile';
    }
  
    headerToggle() {
      this.header = !this.header;
    }
}